"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionItem = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const Checkbox_1 = require("../../../components/input/checkbox/Checkbox");
const Label_1 = require("../../../components/input/label/Label");
const helpers_1 = require("./helpers");
const Paragraph_1 = require("../../../components/paragraph/Paragraph");
const Spacer_1 = require("../../../components/spacer/Spacer");
const PromotionCooldownModal_1 = require("../../../components/promotion-cooldown-modal/PromotionCooldownModal");
const ButtonDetailTag_1 = require("../../../components/button/ButtonDetailTag");
const Wrapper = styled_1.default.div `
	font-family: ${merlin_theme_1.default.typography.fonts.base};
	box-sizing: border-box;
	border-top: 1px solid ${merlin_theme_1.default.colours.neutral.light};
	padding: 20px 0;

	div:last-child {
		margin-right: 0;
	}
`;
const FlexWrapper = styled_1.default.div `
	color: ${merlin_theme_1.default.colours.neutral.black};
	display: flex;
	justify-content: space-between;
	align-items: center;
	${({ hasSubSelections }) => hasSubSelections && 'padding-bottom: 20px;'};

	label {
		padding: 0;
	}
`;
const CheckboxWrapper = styled_1.default.div `
	padding-left: 20px;
	border-left: 1px solid ${merlin_theme_1.default.colours.neutral.light};
`;
;
const getPromotionDecoration = (designation, disabled) => {
    if (disabled)
        return {
            text: 'Not eligible',
            backgroundColor: '#444444'
        };
    if (designation === helpers_1.PromotionDesignation.HIGHLY_RECOMMENDED)
        return {
            text: 'Highly recommended',
            backgroundColor: '#19A77F'
        };
    if (designation === helpers_1.PromotionDesignation.RECOMMENDED)
        return {
            text: 'Recommended',
            backgroundColor: '#19A77F'
        };
};
const showModalOrCheck = (promotion, checked, onCheckboxClick, setModalShowing) => {
    const willTriggerCooloff = promotion.selected && !!promotion.opportunity_cooloff_ms;
    willTriggerCooloff ? setModalShowing() : onCheckboxClick(Object.assign(Object.assign({}, promotion), { selected: checked }));
};
const DetailTagWrapper = styled_1.default.span `
	position: relative;
	bottom: 2px;
`;
const PromotionItem = ({ promotion, onCheckboxClick, }) => {
    const { display_name, internal_reference, selected, description, reason, opportunity_cooloff_ms, disabled, designation } = promotion;
    const [modalShowing, setModalShowing] = React.useState(false);
    const detailTagProps = getPromotionDecoration(designation, disabled);
    return (React.createElement(Wrapper, { "data-testid": `${display_name}-promotion-item`, key: internal_reference },
        React.createElement(FlexWrapper, { hasSubSelections: false },
            React.createElement(Label_1.Label, { htmlFor: display_name },
                display_name,
                !!detailTagProps && React.createElement(DetailTagWrapper, null,
                    React.createElement(ButtonDetailTag_1.ButtonDetailTag, Object.assign({}, detailTagProps)))),
            React.createElement(CheckboxWrapper, null,
                React.createElement(Checkbox_1.Checkbox, { name: internal_reference, onChange: (_, checked) => showModalOrCheck(promotion, checked, onCheckboxClick, () => setModalShowing(true)), checked: selected }))),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(Paragraph_1.Paragraph, { dangerouslySetInnerHTML: { __html: description } }),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(Paragraph_1.Paragraph, null, disabled &&
            React.createElement("p", { style: { fontSize: '14px' } },
                reason,
                " Find out more about eligibility ",
                React.createElement("a", { href: "https://travelnest.freshdesk.com/support/solutions/articles/101000396989-promotions-and-discounts" }, "here"),
                ".")),
        modalShowing &&
            React.createElement(PromotionCooldownModal_1.PromotionCooldownModal, { promotionName: display_name, promotionCooloffTime: opportunity_cooloff_ms, deactivate: () => {
                    onCheckboxClick(Object.assign(Object.assign({}, promotion), { selected: false }));
                }, close: () => setModalShowing(false) })));
};
exports.PromotionItem = PromotionItem;
//# sourceMappingURL=PromotionItem.js.map